export default "__VITE_ASSET__DLlFHF8T__"